<template>
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M0.950378 7.00033C0.950378 7.00033 3.15025 2.60059 7.00002 2.60059C10.8498
      2.60059 13.0497 7.00033 13.0497 7.00033C13.0497 7.00033 10.8498 11.4001 7.00002
      11.4001C3.15025 11.4001 0.950378 7.00033 0.950378 7.00033Z"
      stroke="currentColor"
      stroke-width="1.69704"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M7.00002 8.65023C7.91124 8.65023 8.64992 7.91154 8.64992 7.00033C8.64992
      6.08911 7.91124 5.35042 7.00002 5.35042C6.0888 5.35042 5.35012 6.08911 5.35012
      7.00033C5.35012 7.91154 6.0888 8.65023 7.00002 8.65023Z"
      stroke="currentColor"
      stroke-width="1.69704"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>